export default {
  name: 'AgentSignature',

  props: {
    userDetails: {
      type: Object,
      default: () => ({}),
    },
    agent: {
      type: Object,
      default: () => ({}),
    },
    agentName: {
      type: String,
      default: '---',
    },
    agentNumber: {
      type: String,
      default: '---',
    },
    agentId: {
      type: [String, Number],
      default: null,
    },
    agentUuid: {
      type: String,
      default: null,
    },
    large: Boolean,
  },

  computed: {
    agentNameData() {
      return this.agent.name || this.agentName;
    },
    agentNumberData() {
      return this.agent.nr_tel || this.agentNumber;
    },
    agentIdData() {
      return this.agent.id || this.agentId;
    },
    agentUuidData() {
      return this.agent.uuid || this.agentUuid;
    },
    userDetailsData() {
      return this.agent.user_details || this.userDetails;
    },
    agentType() {
      return this.agent.type || (this.userDetails ? 'agent' : 'unit');
    },
  },

  methods: {
    goToMemebrProfile() {
      const userUuid = this.userDetailsData.user_uuid;
      this.$router.push({
        name: 'PlatformUserDetails',
        params: { userUuid },
      }).then(() => this.$EventBus.$emit('ListOfClientAgents/CHANGE_RETURN_PATH'));
    },
    showAgentProfile() {
      this.$EventBus.$emit('SHOW_AGENT_DETAILS', this.agentUuidData);
    },
  },
};
